<template>
  <div class="p-m-auto" style="width:80%; height:100%;">
    <div class="p-d-flex p-jc-between">
      <span>{{ __("Registered by") }}: {{ data.WorkerName }}</span>
      <span
        >{{ __("Date") }}:
        {{ dateFormat(data.TheDate, true, false, true) }}</span
      >
    </div>
    <div class="p-my-4">
      <span>{{ __("Comment") }}: </span>
      <p-vue-textarea
        :autoResize="true"
        rows="4"
        class="p-inputtext--alt"
        v-model="message"
        v-if="data.IsEdit"
      />
      <label v-else>{{ data.Description }}</label>
    </div>
  </div>
</template>

<script>
import { dateFormat } from "@/services/apointUtil";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { mapState } from "vuex";
import { errorReceived, showSuccessOrFailedModal } from "@/services/apointUtil";
import { __ } from "@/plugins/i18n";
export default {
  props: {
    data: {
      type: Object,
    },
  },
  emits: ["reload"],
  data() {
    return {
      dateFormat,
      message: "",
    };
  },
  mounted() {
    this.message = this.data.Description;
  },
  methods: {
    update() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("UserNum", this.userNum, apiPType.Int),
        apiParam("Num", this.data.ProblemSubNum, apiPType.Int),
        apiParam("PID", this.data.ProblemNum, apiPType.Int),
        apiParam("Description", this.message, apiPType.NVarChar),
        apiParam("ShowToTennat", this.data.showToTennat, apiPType.Bit),
        apiParam("sendToAllTennat", false, apiPType.Bit),
      ];
      callProc("WorkerApp_UpdateOrInsertProblemsSub", procParams)
        .then(() => {
          // result = JSON.parse(result);
          // console.log("WorkerApp_UpdateOrInsertProblemsSub", result);
          this.$emit("reload", "WorkerApp_GetProblemsSubToServiceCall", true);
          this.IsEdit = false;
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_UpdateOrInsertProblemsSub");
        });
    },
    deleteProblemSubInDB() {
      this.$store.dispatch("doLoading", true);
      let procParams = [apiParam("Num", this.data.ProblemSubNum, apiPType.Int)];
      callProc("WorkerApp_DeleteProblemsSub", procParams)
        .then((result) => {
          result = JSON.parse(result);
          // console.log("WorkerApp_DeleteProblemsSub", result);
          if (result.procReturnValue == 0) {
            showSuccessOrFailedModal(__("The update was successfully deleted"));
            setTimeout(() => {
              this.$emit(
                "reload",
                "WorkerApp_GetProblemsSubToServiceCall",
                false
              );
            }, 1000);
          } else {
            showSuccessOrFailedModal(__(result.Table[0].desc), false);
          }
          this.$store.dispatch("doLoading", false);
        })
        .catch(() => {
          errorReceived("WorkerApp_DeleteProblemsSub");
        });
    },
  },
  computed: {
    Delete() {
      return this.data.Delete;
    },
    SaveEditData() {
      return this.data.SaveEditData;
    },
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
  watch: {
    Delete() {
      if (this.Delete) this.deleteProblemSubInDB();
    },
    SaveEditData() {
      if (this.SaveEditData) this.update();
    },
  },
};
</script>

<style scoped>
.p-inputtextarea {
  width: 100%;
}
</style>
